module.exports = __webpack_public_path__ + "assets/ShiftSegment.0466861c752f1aae7064f99749399a4b.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/ShiftSegment.gmt
// module id = 993
// module chunks = 0